export { default } from './DataPolitics';
